// URL Detection Utility
// Detects which platform a URL belongs to

export const detectPlatform = (url) => {
  if (!url) return null;
  
  const lowerUrl = url.toLowerCase();
  
  // TikTok detection
  if (lowerUrl.includes('tiktok.com') || lowerUrl.includes('vm.tiktok.com')) {
    return 'tiktok';
  }
  
  // YouTube detection
  if (
    lowerUrl.includes('youtube.com') || 
    lowerUrl.includes('youtu.be') ||
    lowerUrl.includes('m.youtube.com')
  ) {
    return 'youtube';
  }
  
  // Instagram detection (future)
  if (lowerUrl.includes('instagram.com')) {
    return 'instagram';
  }
  
  // Twitter detection (future)
  if (lowerUrl.includes('twitter.com') || lowerUrl.includes('x.com')) {
    return 'twitter';
  }
  
  return null;
};

export const validateUrl = (url) => {
  if (!url) {
    return { valid: false, message: 'Please enter a video URL' };
  }
  
  const platform = detectPlatform(url);
  
  if (!platform) {
    return { 
      valid: false, 
      message: 'Please enter a valid TikTok or YouTube URL' 
    };
  }
  
  return { valid: true, platform };
};

export const getPlatformName = (platform) => {
  const names = {
    tiktok: 'TikTok',
    youtube: 'YouTube',
    instagram: 'Instagram',
    twitter: 'Twitter'
  };
  
  return names[platform] || 'Unknown';
};
